import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { enable2FA } from "./features/mfaSlice";
import { Card, CardContent, Typography, Box, Grow } from "@mui/material";
import images from "../src/assests/images/bk_img1.jpg";
import logo from "../src/assests/images/logo1.png";
import mfaLogo from "../src/assests/images/auth.png";


const Enable2FA = () => {
  const [showCard, setShowCard] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.mfa);
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    setShowCard(true);
    // Get user email from localStorage
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const email = userData.email;

    if (email) {
      dispatch(enable2FA({ email })).then((result) => {
        if (enable2FA.fulfilled.match(result)) {
          const response = result.payload;
          setQrCode(response.qr);
          // Redirect after 10 seconds
          setTimeout(() => {
            navigate("/verify-mfa");
          }, 10000);
        }
      });
    } else {
      // If no email, redirect back to login
      navigate("/");
    }
  }, [dispatch, navigate]);

  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        // Background image styling
        backgroundImage: `url(${images})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Semi-transparent overlay to improve text readability */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.4)", // Dark overlay for better contrast
          zIndex: 0,
        }}
      />

      {/* Centered card with animation */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        px={2}
        position="relative" // Ensure it's above the overlay
        zIndex={1}
      >
        <Grow in={showCard} timeout={1000}>
          <Card
            sx={(theme) => ({
              width: {
                xs: "90%",
                sm: "65%",
                md: "45%",
                lg: "35%",
                xl: "28%",
              },
              maxWidth: 450,
              padding: 2,
              backgroundColor: "rgba(255, 255, 255, 0.95)", // Slightly transparent white
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: 3,
              borderRadius: 2,
              backdropFilter: "blur(5px)", // Frosted glass effect
            })}
          >
            <CardContent
              sx={{ width: "100%", p: 1, "&:last-child": { pb: 1 } }}
            >
              {/* Logo with description below */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 1.5,
                }}
              >
                <img
                  src={logo}
                  alt="Lucas TVs Logo"
                  style={{ width: "100%", maxWidth: "150px", height: "auto" }}
                />
                <Typography
                  variant="subtitle1"
                  align="center"
                  color="text.primary"
                  fontSize="16px"
                  fontWeight="Bold"
                  sx={{ marginTop: 0.5 }}
                >
                  MFA
                </Typography>
              </Box>

              {/* Scan QR Message */}
              <Typography
                variant="h6"
                align="center"
                sx={{ mb: 2, color: "text.primary" }}
              >
                Scan QR Code to Enable 2FA
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <img
                  src={mfaLogo} 
                  alt="App Logo"
                  style={{
                    width: "333px",
                    height: "100px",
                    objectFit: "contain",
                  }}
                />
              </Box>

              <Typography
                variant="body1"
                align="center"
                sx={{ mb: 3, color: "black" }}
              >
                Use Google Authenticator or Microsoft Authenticator to scan the
                QR code below
              </Typography>

              {/* Loading indicator */}
              {loading && (
                <Typography
                  variant="body2"
                  align="center"
                  sx={{ color: "text.secondary", mb: 2 }}
                >
                  Loading QR Code...
                </Typography>
              )}

              {/* QR Code Display */}
              {qrCode && (
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                  <img
                    src={qrCode}
                    alt="QR Code for 2FA"
                    style={{ maxWidth: "200px", maxHeight: "200px" }}
                  />
                </Box>
              )}

              {qrCode && (
                <Typography
                  variant="body2"
                  align="center"
                  sx={{ color: "text.secondary" }}
                >
                  Redirecting to verification in 10 seconds...
                </Typography>
              )}

              {/* Error message */}
              {error && (
                <Typography
                  variant="body2"
                  align="center"
                  sx={{ color: "error.main", mt: 2 }}
                >
                  {error.message || "Failed to enable 2FA"}
                </Typography>
              )}
            </CardContent>
          </Card>
        </Grow>
      </Box>
    </Box>
  );
};

export default Enable2FA;
